import { all, call, takeLatest } from 'redux-saga/effects';

import { PACKAGES_ACTION_TYPES } from 'store/actions/packages.actions';
import {
  createCoinPackage,
  createPackage, deleteCoinPackage,
  deletePackage, editCoinPackage,
  editPackage,
  loadCoinPackages,
  loadPackages
} from 'api/packages';
import { getRange } from 'utils/rangeHelpers';

function* loadPackagesFlow({ payload, resolve, reject }) {
  try {
    const { price, ...rest } = payload;
    let filters = rest;
    if (price) {
      filters = {
        ...filters,
        ...getRange('price', price)
      }
    }
    const {data} = yield call(loadPackages, filters)
    yield call(resolve, {
      items: data['hydra:member'],
      total: data['hydra:totalItems'],
    })
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* createPackageFlow({ payload, resolve, reject }) {
  try {
    const { data } = yield call(createPackage, payload)
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* editPackageFlow({ payload, resolve, reject }) {
  try {
    const { data } = yield call(editPackage, payload)
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* deletePackageFlow({ payload, resolve, reject }) {
  try {
    const { data } = yield call(deletePackage, payload)
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* loadCoinPackagesFlow({ payload, resolve, reject }) {
  const { coinCount, priceUsd, ...rest } = payload;
  let filters = rest
  if (coinCount) {
    filters = {
      ...filters,
      ...getRange('coinCount', coinCount)
    }
  }
  if (priceUsd) {
    filters = {
      ...filters,
      ...getRange('priceUsd', priceUsd)
    }
  }
  try {
    const { data } = yield call(loadCoinPackages, filters)
    yield call(resolve, {
      items: data['hydra:member'],
      total: data['hydra:totalItems'],
    })
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* createCoinPackageFlow({ payload, resolve, reject }) {
  try {
    const { data } = yield call(createCoinPackage, payload)
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* editCoinPackageFlow({ payload, resolve, reject }) {
  try {
    const { data } = yield call(editCoinPackage, payload)
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* deleteCoinPackageFlow({ payload, resolve, reject }) {
  try {
    const { data } = yield call(deleteCoinPackage, payload)
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

export default function* () {
  yield all([
    takeLatest(PACKAGES_ACTION_TYPES.LOAD_PACKAGES, loadPackagesFlow),
    takeLatest(PACKAGES_ACTION_TYPES.CREATE_PACKAGES, createPackageFlow),
    takeLatest(PACKAGES_ACTION_TYPES.EDIT_PACKAGES, editPackageFlow),
    takeLatest(PACKAGES_ACTION_TYPES.DELETE_PACKAGES, deletePackageFlow),
    takeLatest(PACKAGES_ACTION_TYPES.LOAD_COIN_PACKAGES, loadCoinPackagesFlow),
    takeLatest(PACKAGES_ACTION_TYPES.CREATE_COIN_PACKAGE, createCoinPackageFlow),
    takeLatest(PACKAGES_ACTION_TYPES.EDIT_COIN_PACKAGE, editCoinPackageFlow),
    takeLatest(PACKAGES_ACTION_TYPES.DELETE_COIN_PACKAGE, deleteCoinPackageFlow),
  ])
}